<template>
<div style="position:relative;    z-index: 5;">
<div class="scroll-fixed-bar"
:class="scrollToBottom?'fixed':''"
ref="bar">
  <div class="wrapper">
    <ct-row class="container">
      <ct-col :span="9" class="pagination-large">
        <span class="pager"
          :disabled="questionIndex<=1"
          @click.prevent="changeQuestion(-1)"
        >Last question
          <span class="pager-icon-bg"><ct-icon name="jiantouyou" class="jiantouzuo"></ct-icon></span>
        </span>
        <span class="pager"
          :disabled="questionIndex >= questionListLength"
          @click.prevent="changeQuestion(1)"
        >
          <span class="pager-icon-bg"><ct-icon name="jiantouyou"></ct-icon></span>
          Next question
        </span>
      </ct-col>
      <ct-col :span="15" style="text-align: right">
        <ct-button v-if="question.submitted"
          @click="handleClickMistake"
          :disabled="mistakPending"
          class="action-button"
          :isLoading="mistakPending"
          type="secondary">
          <ct-icon class="action-button-icon" name="add"></ct-icon>Mistake book
        </ct-button>
        <ct-button
          v-if="showAnalysisButton"
          class="action-button"
          :isLoading="analysisPending"
          :disabled="analysisPending"
          @click="getAnalysis"
          type="secondary">
          <ct-icon class="action-button-icon" name="eye-open"></ct-icon>Get solution
        </ct-button>
        <ct-button
          class="action-button check-button"
          type="primary"
          :disabled="checkPending||cannotCheck"
          :isLoading="checkPending"
          @click="submit"
          >Check</ct-button>
      </ct-col>
    </ct-row>
    <edit-wrong-book
    v-if="mistakVisible"
    :key="question.question_id"
    :id="question.question_id"
    :closeCallback="closedMistake"
    :note="mistakNote"
    ></edit-wrong-book>
    <v-awards :awards="skillAwards"
    v-if="skillAwardsVisible"
    :closeCallback="closeAwards"
    ></v-awards>
  </div>
</div>
</div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import EditWrongBook from './sub/EditWrongBook'
import Awards from '@ca/components/Awards'
import moment from 'moment'

export default {
  name: 'QuestionFooter',
  components: {
    'edit-wrong-book': EditWrongBook,
    'v-awards': Awards
  },
  data () {
    return {
      skillAwardsVisible: false,
      skillAwards: null,
      mistakVisible: false,
      mistakNote: '',
      mistakPending: false,
      analysisPending: false,
      checkPending: false,
      scrollToBottom: true,
      offsetTop: 0,
      notAnswer: true,
      originId: Number(this.$route.params.origin)
    }
  },
  watch: {
    question () {
      this.$nextTick(() => {
        this.offsetTop = this.$refs.bar.parentNode.offsetTop
        // this.fixedOnBottom()
      })
    },
    subAnswers (value) {
      let notAnswer = false
      for (let i = 0; i < value.length; i++) {
        const answer = value[i].answer
        if (!answer && answer !== 0) {
          notAnswer = true
          this.notAnswer = notAnswer
          return true
        }
      }
      this.notAnswer = notAnswer
    }
  },
  computed: {
    ...mapGetters(['question', 'paidResult', 'questionIndex', 'questionListLength', 'subAnswers', 'answerIsInvalid', 'questionType']),
    showAnalysisButton () {
      return this.question.submitted && this.question.has_analysis
    },
    cannotCheck () {
      return !this.question.question_id || !!this.question.is_right || this.notAnswer || this.answerIsInvalid
    }
  },
  methods: {
    ...mapActions(['submitQuestion', 'addWrongQuestion', 'payForResult', 'updateQuestionIndex']),
    changeQuestion (offset) {
      const index = this.questionIndex + offset
      if (index >= 0 && index < this.questionListLength) {
        this.updateQuestionIndex(index)
      }
    },
    fixedOnBottom () {
      const windowScrollTop = window.scrollY
      const documentHeight = document.documentElement.clientHeight

      if (documentHeight + windowScrollTop < (this.offsetTop + 30)) {
        this.scrollToBottom = true
      } else {
        this.scrollToBottom = false
      }
    },
    scroll () {
      if (document.addEventListener) {
        // document.addEventListener('scroll', this.fixedOnBottom)
      }
    },
    handleAddWrongQuestion () {
      this.addWrongQuestion({
        data: {
          question_id: this.question.question_id,
          question_type: this.questionType,
          origin: this.originId
        }
      }).then(data => {
        if (data.code === 1) {
          this.mistakVisible = true
        } else if (data.code === 90205) {
          this.mistakNote = data.data || ''
          this.mistakVisible = true
        } else if (data.code === 90206) {
          this.$confirm({
            message: 'Sorry, your usage of 错题本 has reached its limit. You can\'t add a new question unless you delete an old one.',
            cancelButton: 'Cancel',
            confirmButton: 'Go to错题本',
            handleAction: (confirm, resovle, reject) => {
              if (confirm) {
                this.$router.push({
                  name: 'issueList'
                })
                resovle()
              } else {
                reject()
              }
            }
          })
        } else {
          this.$toast({
            message: data.data,
            type: 'error'
          })
        }
        this.mistakPending = false
      }, () => {
        this.mistakPending = false
      })
    },
    handleClickMistake () {
      this.mistakPending = true
      if (this.showAnalysisButton && !this.paidResult) {
        this.payForResult({ params: {
          question_id: this.question.question_id,
          question_type: this.questionType
        } }).then(data => {
          if (data && data.code === 1) {
            this.handleAddWrongQuestion()
          } else {
            this.$toast(data.error || 'Unknow error')
            this.skillAwardsVisible = false
          }
        }, () => {
          this.mistakPending = false
        })
      } else {
        this.handleAddWrongQuestion()
      }
    },
    closeAwards () {
      this.skillAwardsVisible = false
    },
    closedMistake () {
      this.mistakVisible = false
    },
    getAnalysis () {
      if (this.paidResult) {
        const t = document.querySelector('.question-analysis-solution')
        window.scrollTo(0, t.offsetHeight)
        return false
      }
      this.analysisPending = true
      this.payForResult({ params: {
        question_id: this.question.question_id,
        question_type: this.questionType
      } }).then(data => {
        this.analysisPending = false
      }, () => {
        this.analysisPending = false
      })
    },
    addEvent () {
      if (document.addEventListener) {
        document.addEventListener('keyup', this.handleKeyup)
      }
    },
    handleKeyup (event) {
      if (document.body.style.overflow === 'hidden') {
        return false
      }
      const ENTER = event.key.toUpperCase() === 'ENTER' || event.keyCode === 12
      if (!this.cannotCheck && event.shiftKey && ENTER) {
        this.submit()
      }
    },
    hasAward (obj) {
      let count = 0
      for (let key in obj) {
        if (obj[key] > 0) {
          count++
        }
      }
      return count
    },
    submit () {
      this.checkPending = true
      this.$emit('checked-question', {
        questionId: this.question.question_id
      })
      this.submitQuestion({
        data: {
          question_type: this.questionType,
          date: moment().format('YYYY-MM-DD HH:mm:ss'),
          answers: [{
            id: this.question.question_id,
            sub_answers: this.subAnswers
          }]
        }
      }).then(data => {
        this.checkPending = false
        if (data && data.code === 1) {
          const skillAward = data.data.skill_award || { proton: 0, neutron: 0 }
          const questionAward = data.data.question_award || { proton: 0, neutron: 0 }
          const hasSkillAward = this.hasAward(skillAward)
          const hasQuestionAward = this.hasAward(questionAward)
          if (hasSkillAward) {
            this.skillAwardsVisible = true
            this.skillAwards = {
              proton: skillAward.proton + questionAward.proton,
              neutron: skillAward.neutron + questionAward.neutron
            }
            this.$emit('finish-skill')
          } else {
            if (hasQuestionAward) {
              const p = questionAward.proton
              const n = questionAward.neutron
              const awards = `<p style="text-align: center;">Congratulation, you made it！<br><br>PROTON <strong>+${p}</strong>   NEUTRON <strong>+${n}</strong></p>`
              this.$toast({
                message: awards,
                isHtml: true
              })
            }
          }
        } else {
          this.$toast({
            message: data.error,
            type: 'error'
          })
        }
      }, () => {
        this.checkPending = false
      })
    },
    removeEvent () {
      if (document.removeEventListener) {
        document.removeEventListener('keyup', this.handleKeyup)
      }
    }
  },
  mounted () {
    this.offsetTop = this.$refs.bar.parentNode.offsetTop
    // this.fixedOnBottom()
    this.scroll()
    this.addEvent()
  },
  destroyed () {
    this.removeEvent()
  }
}
</script>
<style lang="scss" scoped>
  .scroll-fixed-bar{
    width: 100vw;
    background: #fff;
    padding: 10px;
    box-shadow:0px 2px 14px 0px rgba(79,117,162,0.07);
    // position: absolute;
    // bottom: auto;
    // margin-top: -60px;
    transition: bottom .3s ease;
    .container{
      margin-right: 327px;
      @media (max-width: 1200px){
        margin-right: 0;
      }
    }
    .pagination-large{
      .pager{
        cursor: pointer;
        font-size:14px;
        font-family:SFProDisplay;
        font-weight:400;
        color:rgba(26,61,94,1);
        line-height:16px;
        &-icon-bg{
          display: inline-block;
          width:40px;
          height:40px;
          background:rgba(239,244,250,1);
          border-radius:2px;
          text-align: center;
          padding-top: 14px;
        }
      }
      .pager + .pager{
        margin-left: 8px;
      }
    }
    &.fixed{
      position: fixed;
      bottom: 0;
      transition: bottom .3s ease;
      z-index: 1200;
    }
    .action-button{
      margin-left: 16px;
      &-icon{
        margin-right: 8px;
        font-size: 18px;
        vertical-align: middle;
        margin-top: -3px;
      }
    }
    .jiantouzuo{
      transform: rotate(180deg);
    }
  }
</style>
